import { RowSelectionState } from '@tanstack/react-table';

export function findNewlySelectedRow(
  action: React.SetStateAction<RowSelectionState>,
  prev: RowSelectionState
) {
  let next = action;
  if (typeof action === 'function') {
    next = action(prev);
  }
  return Object.keys(next).find((id) => next[id] && !prev[id]);
}
